import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ErrorMessage from './error-message';
import ErrorMessageDetail from './error-message-detail';
import ErrorMessageUpdate from './error-message-update';
import ErrorMessageDeleteDialog from './error-message-delete-dialog';

const ErrorMessageRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ErrorMessage />} />
    <Route path="new" element={<ErrorMessageUpdate />} />
    <Route path=":id">
      <Route index element={<ErrorMessageDetail />} />
      <Route path="edit" element={<ErrorMessageUpdate />} />
      <Route path="delete" element={<ErrorMessageDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ErrorMessageRoutes;
